import { round } from 'intl-utils';

onLoad();

export function onLoad() {
    document.addEventListener('product:view', e => {
        dataLayer.push({
            'event': 'select_item',
            'ecommerce': {
                'currency': config.currency,
                'items': [{
                    'item_id': e.detail.id.toString(),
                    'item_name': e.detail.name,
                    'item_category': e.detail.categoryName,
                    'item_brand': e.detail.brandName,
                    'price': round(e.detail.price / 100 * (100 + e.detail.taxRate), 2),
                    'quantity': e.detail.quantity ?? 1,
                    'index': 0
                }]
            }
        });
    });

    document.addEventListener('cart:added', e => {
        dataLayer.push({
            'event': 'add_to_cart',
            'ecommerce': {
                'currency': config.currency,
                'items': e.detail.items.map((item, i) => ({
                    'item_id': item.id.toString(),
                    'item_name': item.name,
                    'item_category': item.categoryName,
                    'item_brand': item.brandName,
                    'price': round(item.price / 100 * (100 + item.taxRate), 2),
                    'quantity': item.quantity,
                    'index': i
                }))
            }
        });
    });

    document.addEventListener('cart:removed', e => {
        dataLayer.push({
            'event': 'remove_from_cart',
            'ecommerce': {
                'currency': config.currency,
                'items': e.detail.items.map((item, i) => ({
                    'item_id': item.id.toString(),
                    'item_name': item.name,
                    'item_category': item.categoryName,
                    'item_brand': item.brandName,
                    'price': round(item.price / 100 * (100 + item.taxRate), 2),
                    'quantity': item.quantity,
                    'index': i
                }))
            }
        });
    });
}